import React, { useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

const HistoriaIA = () => {
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const handleShow = (url) => {
    setVideoUrl(url);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoUrl("");
  };

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: El Nacimiento de una Idea (1940s-1956)",
      url: `${videoBaseURL}H1.mp4`,
      contenido: [
        "Los sueños filosóficos y mecánicos.",
        'Alan Turing y la pregunta: "¿Pueden pensar las máquinas?".',
        'El "bautizo" oficial: La Conferencia de Dartmouth.',
      ],
    },
    {
      nombre: "Video 2: La Montaña Rusa - Hype y los 'Inviernos' (1960s-1990s)",
      url: `${videoBaseURL}H2.mp4`,
      contenido: [
        'El optimismo inicial y la IA "Simbólica" (basada en reglas).',
        "El Primer Invierno de la IA: La realidad golpea y los fondos se cortan.",
        'El breve resurgir de los "Sistemas Expertos" y el Segundo Invierno.',
      ],
    },
    {
      nombre: "Video 3: El Renacimiento - Datos, Poder y ML (1990s-2012)",
      url: `${videoBaseURL}H3.mp4`,
      contenido: [
        "El ingrediente secreto: El Machine Learning (enfoque estadístico).",
        'El "Kaspárov" de la IA: Deep Blue vence al ajedrez.',
        'La tormenta perfecta: La llegada de Big Data, GPUs y el "momento AlexNet".',
      ],
    },
    {
      nombre: "Video 4: La Revolución Actual - La Era Generativa (2017-Hoy)",
      url: `${videoBaseURL}H4.mp4`,
      contenido: [
        "El gran salto: De predecir a crear.",
        '"Attention Is All You Need": El nacimiento de la arquitectura Transformer.',
        "La explosión de los LLMs (GPT, BERT) y la IA Generativa (DALL-E, Midjourney).",
      ],
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="text-center">
          <h1 className="mt-4">Historia de la Inteligencia Artificial</h1>
          <hr className="linea-horizontal" />
        </div>

        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Título del Video</th>
                <th>Contenido</th>
                <th>Reproducir</th>
              </tr>
            </thead>

            <tbody>
              {videos.map((video, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td><b>{video.nombre}</b></td>
                  <td>
                    <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                      {video.contenido.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>
                  <td>
                    <Button
                      className="boton"
                      variant="primary"
                      onClick={() => handleShow(video.url)}
                    >
                      Reproducir Video
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>

      {/* Modal para reproducir video */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Reproducción de Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HistoriaIA;
